<template>
  <div
    style="background-color: #fff;line-height: 1;font-family: 'Microsoft Yahei', Verdana, Arial, Helvetica, sans-serif;
  font-size: 100%;"
  >
    <div class="topimg">
      <img src="@assets/images/topimg.png" />
      <div class="apher">
        <b>幸运星驾到！做幸运达人</b>
        <p>
          规则说明：每件商品限定参加人数，每人支付商品金额后，系统定时开奖，发放奖品
        </p>
      </div>
    </div>

    <div class="cj-list">
      <span>
        <a
          v-for="(item, index) in titleList"
          :key="index"
          :class="index === current ? 'cur' : ''"
          @click="checkTab(index)"
          >{{ item }}</a
        >
      </span>

      <div class="cj-box">
        <dl v-for="item in list" :key="item.id">
          <dt>
            <a><img :src="item.image"/></a>
          </dt>
          <dd>
            <ul>
              <li>
                原价: <em>￥{{ item.ot_price }}</em>
              </li>
              <li>
                幸运价: <b>￥{{ item.single_price }}</b>
              </li>
              <li>
                截止:
                <p>{{ item.stop_time_format }}</p>
              </li>
              <li>
                开奖:
                <p>{{ item.publish_time_format }}</p>
              </li>
              <li v-show="current !== 2">
                最低人数:
                <p>{{ item.min_people_num }}人</p>
              </li>
              <li v-show="current === 0" style="color: red">
                中奖人数:
                <p>{{ item.num }}人</p>
              </li>
              <li v-show="current === 2 && item.win_phones" style="color: red">
                中奖用户:
                <p style="overflow: hidden;text-overflow: ellipsis;word-spacing: normal;width: calc(100% - 10px);display: block;">{{ item.win_phones }}</p>
              </li>
              <li
                v-show="current === 2"
                :style="item.is_winning == 1 ? 'color:red' : 'color:#a2a2a2'"
              >
                {{ item.is_winning == 1 ? "恭喜您中奖!": item.is_winning == 2 ?  "未参与" : "很遗憾,没有中奖!" }}
              </li>
              <a v-show="current === 0" @click="draw(item)">立即抽奖</a>
            </ul>
          </dd>
        </dl>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="apher-tip" @click="showFlag = false" v-show="showFlag"></div>
    <div class="tip-box" v-show="showFlag">
      <h2>余额支付</h2>
      <div>
        <b>￥{{ payMoney }}</b>
        <span>支付金额</span>
        <p :style="this.money * 1 < this.payMoney ? '' : 'visibility:hidden'">
          你的余额不足，
          <router-link :to="'/user/Recharge'">去充值</router-link>
        </p>
        <button @click="pay">确认支付</button>
      </div>
    </div>
    <!-- 弹框 -->
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import { getLuckyList, getMoney, payLucky } from "@api/user";
export default {
  name: "LuckyDraw",
  data() {
    return {
      titleList: ["限时抽奖", "等待开奖", "往期开奖"],
      current: 0,
      page: 1,
      limit: 10,
      loading: false,
      loaded: false,
      list: [],
      showFlag: false,
      payMoney: "",
      money: "",
      id: ""
    };
  },
  watch:{
    $route(to,from){
     this.showFlag = false
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    pay() {
      if (this.money * 1 < this.payMoney) {
        return this.$dialog.toast({ mes: "余额不足" });
      } else {
        payLucky({
          id: this.id
        })
          .then(res => {
            this.showFlag = false;
            this.$dialog.toast({ mes: res.msg });
            this.getList();
          })
          .catch(err => {
            this.$dialog.toast({ mes: err.msg });
          });
      }
    },
    draw(item) {
      this.id = item.id;
      getMoney().then(res => {
        this.showFlag = true;
        this.payMoney = item.single_price;
        this.money = res.data.result;
      });
    },
    getList() {
      const { page, limit, current } = this;
      if (this.loading || this.loaded) return;
      this.loading = true;
      getLuckyList({
        page,
        limit,
        type: current + 1
      }).then(res => {
        this.list = this.list.concat(res.data.list);
        this.loading = false;
        this.loaded = res.data.list.length < limit;
        this.page++;
      });
    },
    checkTab(index) {
      this.list = [];
      this.current = index;
      this.loading = false;
      this.loaded = false;
      this.page = 1;
      const { page, limit } = this;
      if (this.loading || this.loaded) return;
      this.loading = true;
      getLuckyList({
        page,
        limit,
        type: index + 1
      }).then(res => {
        this.list = this.list.concat(res.data.list);
        this.loading = false;
        this.loaded = res.data.list.length < limit;
        this.page++;
      });
    }
  }
};
</script>

<style scoped>
.topimg {
  position: relative;
  height: 155px;
}
.topimg img {
  position: absolute;
  z-index: 1;
  width: 100%;
}

.apher {
  background: url(../../assets/images/apher.png);
  height: 112px;
  margin: 0 30px;
  position: relative;
  z-index: 3;
  top: 15px;
}
.apher b {
  display: block;
  font-size: 20px;
  color: #fff;
  text-align: center;
  padding-top: 24px;
  padding-bottom: 15px;
}
.apher p {
  font-size: 12px;
  color: #fff;
  display: block;
  padding: 0 10px;
  line-height: 19px;
}
.cj-list {
  padding-top: 10px;
}
.cj-list span {
  display: block;
  border-bottom: 1px solid #dedede;
  height: 53px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
}
.cj-list span a {
  display: inline-block;
  margin: 0 0.5rem;
}
.cj-list span a.cur {
  border-bottom: 3px solid #0066cc;
  color: #0066cc;
}
.cj-box {
  padding: 11px;
}
.cj-box dl {
  display: block;
  width: calc((100% / 2) - 5px);
  height: 290px;
  float: left;
  background: #f9f9f9;
  margin-bottom: 10px;
}
.cj-box dl:nth-child(2n) {
  float: right;
}
.cj-box dl dt {
  display: block;
  height: 100px;
  overflow: hidden;
}
.cj-box dl dt img {
  height: 100%;
  height: 100%;
}
.cj-box dl dd {
  padding: 10px;
}
.cj-box dl dd ul li {
  display: block;
  line-height: 24px;
  font-size: 12px;
  color: #666666;
}
.cj-box dl dd ul li b {
  color: #ff6600;
  font-size: 14px;
}
.cj-box dl dd ul li em {
  display: block;
  padding-left: 5px;
  text-decoration: line-through;
  display: inline;
}
.cj-box dl dd ul li p {
  display: inline;
}
.cj-box dl dd ul a {
  font-size: 12px;
  color: #ffffff;
  background: #0066cc;
  border-radius: 3px;
  display: block;
  margin: 10px auto;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}
.apher-tip {
  width: 100%;
  height: 100%;
  background: url(../../assets/images/apher-tip.png);
  position: fixed;
  top: 0;
  z-index: 666;
}
.tip-box {
  background: #ffffff;
  border-radius: 3px;
  position: fixed;
  z-index: 999;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 320px;
  height: 213px;
}
.tip-box h2 {
  display: block;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #dedede;
  padding: 0 20px;
}
.tip-box div b {
  font-size: 24px;
  font-weight: bold;
  color: #ff6600;
  display: block;
  text-align: center;
  padding-top: 18px;
  padding-bottom: 5px;
}
.tip-box div span {
  display: block;
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.tip-box div p {
  font-size: 14px;
  display: block;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 10px;
}
.tip-box div p a {
  color: #0066cc;
}
.tip-box div button {
  font-size: 12px;
  color: #ffffff;
  background: #0066cc;
  border-radius: 3px;
  display: block;
  margin: 10px auto;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: none;
}
.cj-box dl.yzj dd {
  background: url(../../assets/images/zj.png) right bottom no-repeat;
  background-size: 68px;
}
.cj-box dl.wzj dd {
  background: url(../../assets/images/wzj.png) right bottom no-repeat;
  background-size: 68px;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  list-style: none;
}
textarea,
input[type="text"],
input[type="password"],
input[type="datetime"],
input[type="datetime-local"],
input[type="date"],
input[type="month"],
input[type="time"],
input[type="week"],
input[type="number"],
input[type="email"],
input[type="url"],
input[type="search"],
input[type="tel"],
input[type="color"],
.uneditable-input,
select,
textarea,
input[type="text"],
input[type="password"],
input[type="datetime"],
input[type="datetime-local"],
input[type="date"],
input[type="month"],
input[type="time"],
input[type="week"],
input[type="number"],
input[type="email"],
input[type="url"],
input[type="search"],
input[type="tel"],
input[type="color"],
.uneditable-input {
  border: none;
  padding: 0px;
  margin: 0px;
}
input[type="button"],
input[type="submit"],
input[type="reset"] {
  -webkit-appearance: none;
}
textarea {
  -webkit-appearance: none;
  resize: none;
}
body {
  line-height: 1;
  font-family: "Microsoft Yahei", Verdana, Arial, Helvetica, sans-serif;
  background: #ffffff;
  font-size: 100%;
  overflow-x: hidden;
}
ol,
ul,
li {
  list-style: none;
}
table {
}
caption,
th,
td {
  vertical-align: middle;
  text-align: left;
  font-weight: normal;
}
q,
blockquote {
  quotes: none;
}
q:before,
q:after,
blockquote:before,
blockquote:after {
  content: "";
  content: none;
}
a img {
  border: 0;
  text-decoration: none;
}
strong,
b {
  font-weight: bold;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary {
  display: block;
}
h1,
h2,
h3,
h4,
h5 {
  font-weight: normal;
  font-size: 100%;
  padding: 0px;
  margin: 0px;
  text-indent: 0px;
}
a:hover {
  text-decoration: none;
}
a {
  color: #515151;
  text-decoration: none;
}
input[type="button"],
input[type="submit"],
input[type="reset"] {
  -webkit-appearance: none;
}
textarea {
  -webkit-appearance: none;
}
button,
input {
  border-radius: 0;
}
img {
  display: inline-block;
  max-height: 100%;
  max-width: 100%;
}
header input::-webkit-input-placeholder,
header textarea::-webkit-input-placeholder {
  color: #fff;
}
i,
em {
  font-style: normal;
}

/* 清除 */
.clear {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  content: "";
  display: block;
  clear: both;
  zoom: 1;
}
button,
input {
  background-color: transparent;
  outline: none;
}
</style>
